import { forwardRef, ForwardedRef } from 'react';

import { Sizes, TABLE_CLASS } from '@sede-x/shell-ds-react-base';

import { ICheckboxProps } from '../../../Checkbox/Checkbox.types';
import { useTable } from '../../hooks/useTable';
import Checkbox from '../../../Checkbox/Checkbox';
import { getSize } from '../../utils/tableUtils';

export const SelectionCheckbox = forwardRef(({ ...rest }: ICheckboxProps, ref: ForwardedRef<HTMLInputElement>) => {
  const { size = Sizes.Medium } = useTable();

  return (
    <Checkbox
      className={`${TABLE_CLASS}-checkbox`}
      aria-label="Table checkbox"
      size={getSize(size)}
      ref={ref}
      {...rest}
    />
  );
});
